export default __webpack_public_path__ + "static/media/overviewOld.fb78ffcf.png";